import React, { useState } from "react";
import "./DropDown.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";



const DropDown = () => {
  const [hoveredMain, setHoveredMain] = useState(false);
  const [hoveredSub, setHoveredSub] = useState("");

  const handleMainHover = (isHovered) => {
    setHoveredMain(isHovered);
  };

  const handleSubHover = (item) => {
    setHoveredSub(item);
  };

  return (
    <div className="container mt-6">
      <div className="card">
        <div className="card-header">
          <h4>Drop Down</h4>
        </div>
        <div className="card-body">
          <div className="dropdown-container">
            <div
              className="main-menu"
              onMouseEnter={() => handleMainHover(true)}
              onMouseLeave={() => handleMainHover(false)}
            >
              <div class="btn-group">
                <button type="button" class="btn btn-secondary btn-me">Women</button>
                <button type="button" class="btn btn-secondary btn-me dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="visually-hidden">Toggle Dropdown</span>
                </button>
              </div>
              {hoveredMain && (
                <div className="dropdown">
                  <ul>
                    <li
                      onMouseEnter={() => handleSubHover("Saree")}
                      onMouseLeave={() => handleSubHover("")}
                    >
                      <span>Saree</span>
                      <span><FontAwesomeIcon icon={faAngleDown} className="float-end mt-1 f-14" /></span>
                      {hoveredSub === "Saree" && (
                        <div className="sub-dropdown">
                          <ul>
                            <li>
                              <div class="form-froup">
                                <div class="checkbox-section d-inline-block">
                                  <input class="checkbox" type="checkbox" id="checkbox-2" />
                                  <label class="form-label checkbox-label" for="checkbox-2">Party Saree</label>
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="form-froup">
                                <div class="checkbox-section d-inline-block">
                                  <input class="checkbox" type="checkbox" id="checkbox-3" />
                                  <label class="form-label checkbox-label" for="checkbox-3">Festival Saree</label>
                                </div>
                              </div>
                            </li>
                            <li>
                              <div class="form-froup">
                                <div class="checkbox-section d-inline-block">
                                  <input class="checkbox" type="checkbox" id="checkbox-4" />
                                  <label class="form-label checkbox-label" for="checkbox-4">Casual Saree</label>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </li>
                    <li
                      onMouseEnter={() => handleSubHover("Salwar Suit")}
                      onMouseLeave={() => handleSubHover("")}
                    >
                      <span>Salwar Suit</span>
                      <span><FontAwesomeIcon icon={faAngleDown} className="float-end mt-1 f-14" /></span>
                      {hoveredSub === "Salwar Suit" && (
                        <div className="sub-dropdown">
                          <ul>
                            <li>
                              <a href="/party-saree">Salwar Suit 1</a>
                            </li>
                            <li>
                              <a href="/festival-saree">Festival Saree</a>
                            </li>
                            <li>
                              <a href="/casual-saree">Casual Saree</a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </li>
                    <li
                      onMouseEnter={() => handleSubHover("Lehenga")}
                      onMouseLeave={() => handleSubHover("")}
                    >
                      <span>Lehenga</span>
                    </li>
                    <li
                      onMouseEnter={() => handleSubHover("Lehenga")}
                      onMouseLeave={() => handleSubHover("")}
                    >
                      <span>Gown</span>
                    </li>
                    <li
                      onMouseEnter={() => handleSubHover("Lehenga")}
                      onMouseLeave={() => handleSubHover("")}
                    >
                      <span>Kurti</span>
                    </li>
                    <li
                      onMouseEnter={() => handleSubHover("Lehenga")}
                      onMouseLeave={() => handleSubHover("")}
                    >
                      <span>Indo Westurn</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropDown;
